/*
 * lp-prescription (schema)
 */
import { boolean, doublePrecision, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { prescriptions } from "../prescription/prescription.schema"

export const lpPrescriptions = schema.table("lp_prescriptions", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	prescriptionId: uuid("prescription_id")
		.notNull()
		.references(() => prescriptions.id, { onDelete: "cascade" }),
	licencedProducerId: uuid("licenced_producer_id"),
	lpName: varchar("lp_name", { length: 256 }),
	replacedById: uuid("replaced_by_id"),
	mdAttachmentId: uuid("md_attachment_id"),

	// --- Dosage ---
	splitAmount: doublePrecision("split_amount"),
	minThc: doublePrecision("min_thc"),
	maxThc: doublePrecision("max_thc"),
	minCbd: doublePrecision("min_cbd"),
	maxCbd: doublePrecision("max_cbd"),

	// --- Dates ---
	startDate: timestamp("start_date", { withTimezone: true }),
	endDate: timestamp("end_date", { withTimezone: true }),

	// --- Notes ---
	reasonForChange: text("reason_for_change"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
